import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Card from "../../../UI/Card/Card";
import Button from "../../../UI/Button/Button"
import ErrorPanel, { ErrorSize } from "../../../UI/ErrorPanel/ErrorPanel";

import { faEdit } from "@fortawesome/free-solid-svg-icons";

import * as ApplicationConstant from "../../../Constants/ApplicationConstant";
import * as ContactUtils from "../../../Utils/ContactUtils";
import * as ApplicationsUtils from "../../../Utils/ApplicationsUtils";
import * as ApplicationsActions from "../../../../middleware/Store/Actions/ApplicationsActions";
import * as SandBoxApplicationsActions from "../../../../middleware/Store/Actions/SandBoxApplicationsActions";
import * as ErrorUtils from "../../../Utils/ErrorUtils";

import LogService from "../../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APP-EDITION-MODEL";

const Model = (props) => {

    const intl = useIntl();
    const [kpi, setKpi] = useState(ApplicationConstant.ModelType.PayAsYouGo);
    const [application, setApplication] = useState(null);
    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect application");
        if (props.applicationId) {
            const foundApplication = ApplicationsUtils.getApplicationById(props.applicationId, props.applications);
            setApplication(foundApplication);
            if (foundApplication && foundApplication.kpi) {
                setKpi(foundApplication.kpi);
            }

            if (props.applicationId !== application?.id) {
                setProgress(false);
                setErrorMessage("");
            }
        }
    }, [props.applications, props.applicationId]);;

    const handleUpdate = (event) => {
        LogService.trace(LOG_TAG, "handleUpdate", event.target.value);
        const criteria = {
            kpi: kpi
        };

        setProgress(true);
        props.update(application?.id, criteria)
            .then(() => {
                LogService.debug(LOG_TAG, "handleUpdate success");
                setProgress(false);
            })
            .catch((errorPayload) => {
                LogService.debug(LOG_TAG, "handleUpdate error");
                setProgress(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
            });
    };

    const handleKpiChange = (event) => {
        setKpi(event.target.value);
    };

    LogService.trace(LOG_TAG, "render");

    let modelOptions = Object.entries(ApplicationConstant.ModelTypeLabel).map(([key, value], i) => {
        let disable = false;
        let hidden = false;
        if (key === ApplicationConstant.ModelType.Internal) {
            disable = true;
            hidden = true;
            if (ContactUtils.isSuperAdminOrAppSuperAdmin(props.user)) {//server will check if owner is internal developper
                disable = false;
                hidden = false;
            } else if (ApplicationsUtils.isMyApplication(application, props.user)) {
                disable = !ContactUtils.isInternalDeveloper(props.user);
                hidden = disable;
            }
        } else if (key === ApplicationConstant.ModelType.RainbowStore) {
            disable = true;
            hidden = true;
        } else if (key === ApplicationConstant.ModelType.Demo) {
            disable = true;
            hidden = true;
        }

        return (
            <option value={key} key={key} disabled={disable} hidden={hidden}>
                {value}
            </option>
        );
    });

    let modelMessage = intl.formatMessage({ id: "applicationEditionModelPayAsYouGoMessage" }, { b: chunks => <b>{chunks}</b> });
    if (kpi === ApplicationConstant.ModelType.Business) {
        modelMessage = intl.formatMessage({ id: "applicationEditionModelBusinessMessage" }, { b: chunks => <b>{chunks}</b>, link: <a target="_blank" className="btn-link" href={"./legals/Rainbow_BKPI_Deployment_RequestForm.docx"} rel="noopener noreferrer">Business Deployment Request</a>});
    } else if (kpi === ApplicationConstant.ModelType.Internal) {
        modelMessage = intl.formatMessage({ id: "applicationEditionModelInternalMessage" }, { b: chunks => <b>{chunks}</b> });
    } else if (kpi === ApplicationConstant.ModelType.RainbowStore) {
        modelMessage = "";
    }

    return (
        <Card title={intl.messages.applicationEditionModelOfferTitle}>
            <div className="form-group">
                <label htmlFor="target" className="input-label">{intl.messages.applicationEditionModelOfferLabel}</label>
                <select
                    className="form-control mb-3"
                    value={kpi}
                    onChange={handleKpiChange}
                    disabled={!props.isUpdateEnabled}
                >
                    {modelOptions}
                </select>
            </div>

            {props.isUpdateEnabled && modelMessage.length > 0 &&
                <div id="modelMessage" className="panel bg-fog mb-3">{modelMessage}</div>
            }

            {props.isUpdateEnabled &&
                <div>
                    <Button
                        label={intl.messages.update}
                        icon={faEdit}
                        onClick={handleUpdate}
                        spinner={progress}
                        disabled={progress}
                        className="btn-submit"
                    />
                    {errorMessage &&
                        <div className="mt-2">
                            <ErrorPanel size={ErrorSize.Small} >{errorMessage}</ErrorPanel>
                        </div>
                    }
                </div>
            }
        </Card >
    );
}

Model.propTypes = {
    applicationId: PropTypes.string,
    isUpdateEnabled: PropTypes.bool,
    isSandBoxApplication: PropTypes.bool
};

Model.defaultProps = {
    applicationId: "",
    isUpdateEnabled: false,
    isSandBoxApplication: false
}

const mapStateToProps = (state, props) => {
    return {
        user: props.isSandBoxApplication ? state.sandBoxContacts.user : state.contacts.user,
        applications: props.isSandBoxApplication ? state.sandBoxApplications.applications : state.applications.applications,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        update: (appId, criteria) => dispatch(props.isSandBoxApplication ? SandBoxApplicationsActions.updateApplication(appId, criteria) : ApplicationsActions.updateApplication(appId, criteria))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Model);